import Api from '../Api';

import { url } from './config';
import { Category } from './types';

const api = new Api<Category>(url);

export default api;
